import type { Project } from "@tudigo-monorepo/core-tudigo-api-models";
import {
  ComparatorSelectionList,
  ComparatorTable,
  ComparatorTableContent,
  ComparatorTableRow,
  ComparatorTableRowLabel,
  ComparatorTableRowValue,
  ComparatorTableTrigger,
} from "@tudigo-monorepo/web-tudigo-comparator";
import { CountryFlag } from "@tudigo-monorepo/web-tudigo-components";

export function ProjectsComparatorGeneralInformationsTable() {
  return (
    <ComparatorTable defaultOpen>
      <ComparatorTableTrigger>Informations générales</ComparatorTableTrigger>
      <ComparatorTableContent>
        <ComparatorTableRow>
          <ComparatorTableRowLabel>Date de création</ComparatorTableRowLabel>
          <ComparatorSelectionList>
            {(project: Project) => (
              <ComparatorTableRowValue loaderClassName="w-1/6">
                {project.information?.foundedYear
                  ? project.information.foundedYear.toString().slice(0, 4)
                  : "N/A"}
              </ComparatorTableRowValue>
            )}
          </ComparatorSelectionList>
        </ComparatorTableRow>

        <ComparatorTableRow>
          <ComparatorTableRowLabel>Localisation</ComparatorTableRowLabel>
          <ComparatorSelectionList>
            {(project: Project) => (
              <ComparatorTableRowValue loaderClassName="w-1/2">
                {project.information?.location?.city &&
                project.information?.location?.country ? (
                  <>
                    <CountryFlag
                      countryCode={project.information.location.country}
                      className="mr-2"
                    />
                    {project.information.location?.city},{" "}
                    {project.information.location?.country}
                  </>
                ) : (
                  "N/A"
                )}
              </ComparatorTableRowValue>
            )}
          </ComparatorSelectionList>
        </ComparatorTableRow>

        <ComparatorTableRow>
          <ComparatorTableRowLabel>
            Stade de financement
          </ComparatorTableRowLabel>
          <ComparatorSelectionList>
            {(project: Project) => (
              <ComparatorTableRowValue loaderClassName="w-1/3">
                {project.maturity?.name ?? "N/A"}
              </ComparatorTableRowValue>
            )}
          </ComparatorSelectionList>
        </ComparatorTableRow>
      </ComparatorTableContent>
    </ComparatorTable>
  );
}
